import React, { useContext } from 'react';
import JourneyBarStep from './JourneyBarStep';
import { journeyBarContainerStyle, emptyJourneyBarStyle } from './JourneyBarStyles';
import { AirtimePlanningContext } from '../../../contexts/AirtimePlanningContext';

const JourneyBar = ({
    currentStep,
    setCurrentStep,
}) => {
    const { journeyBarSteps, setJourneyBarSteps } = useContext(AirtimePlanningContext);

    const handleStepClick = (index, step) => {
        if (!step.enabled) {
            return;
        }

        setCurrentStep(index);
        const stepsCopy = [...journeyBarSteps];
        stepsCopy?.forEach((s, i) => {
            if (s.name === step.name) {
                s.currentStep = true;
            } else {
                s.currentStep = false;
            }
        });

        setJourneyBarSteps(stepsCopy);

        window.scrollTo(0, 0);
    };

    const drawJourneyBar = () => {
        if (journeyBarSteps.length > 0) {
            return journeyBarSteps
                .filter((s) => !s.hidden)
                .map((step, i) => {
                    return (
                        <JourneyBarStep
                            key={`step${i}`}
                            step={step}
                            index={i}
                            currentStep={currentStep}
                            setCurrentStep={setCurrentStep}
                            onClick={handleStepClick}
                            width={journeyBarContainerStyle.width / journeyBarSteps.filter((s) => !s.hidden).length}
                        />
                    );
                });
        } else {
            return <div style={emptyJourneyBarStyle}>&nbsp;</div>;
        }
    };

    return <div style={journeyBarContainerStyle}>{drawJourneyBar()}</div>;
};

export default JourneyBar;
